import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { useLanguage } from '../../context/LanguageContext';
import Input from '../../components/common/Input';
import Button from '../../components/common/Button';
import './Register.css';

const Register = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const { t } = useLanguage();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError(t('register.passwordMismatch'));
      return;
    }

    setLoading(true);
    try {
      await register({
        name: formData.name,
        email: formData.email,
        password: formData.password,
      });
      navigate('/user/dashboard');
    } catch (err) {
      console.error('Registration error:', err.response?.data || err);
      const errorMsg = err.response?.data?.message || err.response?.data?.error || t('register.failed');
      setError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-page">
      <div className="register-container">
        <div className="register-header">
          <h1>{t('register.title')}</h1>
          <p>{t('register.subtitle')}</p>
        </div>

        {error && (
          <div className="error-message">
            <span>⚠️</span>
            <p>{error}</p>
          </div>
        )}

        <form onSubmit={handleSubmit} className="register-form">
          <div className="form-group">
            <Input
              label={t('register.fullName')}
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder={t('register.fullNamePlaceholder')}
            />
          </div>

          <div className="form-group">
            <Input
              label={t('common.email')}
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="your@email.com"
            />
          </div>

          <div className="form-group">
            <Input
              label={t('common.password')}
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder="••••••••"
            />
          </div>

          <div className="form-group">
            <Input
              label={t('register.confirmPassword')}
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
              placeholder="••••••••"
            />
          </div>

          <div className="terms-agreement">
            <label>
              <input type="checkbox" required />
              <span>
                {t('register.agree')}{' '}
                <Link to="/terms" className="terms-link">
                  {t('register.terms')}
                </Link>
              </span>
            </label>
          </div>

          <Button type="submit" disabled={loading} className="register-button">
            {loading ? t('register.loading') : t('register.submit')}
          </Button>
        </form>

        <div className="register-divider">
          <span>{t('common.or')}</span>
        </div>

        <p className="login-prompt">
          {t('register.haveAccount')}{' '}
          <Link to="/login" className="login-link">
            {t('register.signIn')}
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Register;



